import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './assets/css/style.css';
import { useSelector } from 'react-redux';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { UserRoutes, UserKbankRoutes } from './routes/userRoutes';
import AuthRoutes from './routes/authRoutes';

import { App as AntdApp, ConfigProvider } from 'antd';

function App() {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const isUserKbank = useSelector((state) => state.user)?.info?.username === 'kbank';

  const UserRoutesPage = () => {
    const allPages = useRoutes(isUserKbank ? UserKbankRoutes : UserRoutes);
    return allPages;
  };

  const AuthRoutesPage = () => {
    const allPages = useRoutes(AuthRoutes);
    return allPages;
  };

  const queryClientOption = {
    defaultOptions: {
      queries: { refetchOnWindowFocus: false, retry: false, staleTime: 1000 * 5 },
    },
  };
  const queryClient = new QueryClient(queryClientOption);
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <AntdApp notification={{ placement: 'topRight' }}>
          <BrowserRouter>{isLoggedIn ? <UserRoutesPage /> : <AuthRoutesPage />}</BrowserRouter>
        </AntdApp>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
